import axios from "axios";
import api from "./api";

export default class VendasBolePixLoteApi {
  static postVendaBoletoLote = async (body: any) => {
    const response = await api.post(`/bolepix/gerar-lote`, body);
    return response.data;
  };

  static postVendaBoletoLoteVisualizacao = async (body: any) => {
    const response = await api.post(`/bolepix/gerar-lote/visualizacao`, body);
    return response.data;
  };

  static getStatusLote = async (idLote: string) => {
    const response = await api.get(`/bolepix/lote/${idLote}/status`);
    return response.data;
  };
}
